import {
  Box,
  Breadcrumbs,
  Button,
  IconButton,
  Input,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import DiscountModal from "../../common/discountModel";
import SearchIcon from "@mui/icons-material/Search";

import ReactToPrint from "react-to-print";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Grid from "@mui/material/Grid";
import AddIcCallIcon from "@mui/icons-material/AddIcCall";

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { getUserDetailByNumber, UpdateBillCounterSell } from "./updateBillApi";
import { useSelector } from "react-redux";
import { routePath } from "../../constants/routePath";
import MenuSideBar from "../../common/menuSideBar";
import Swal from "sweetalert2";
import PrintBilling from "../../common/printBilling";
import { addBill, updateBil } from "./updateBillApiHandler";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { updateBillValidation } from "./updateBillValidationFunctions";
import { TotalAmount, validationUpdate } from "./updateBillingFunctions";
import Pop from "./pop";
import { isArray } from "lodash";
import PrintBillingPdf from "../../common/printBillingPdf";
import { removetableOrder } from "../counterSellBilling/fireBaseFunctions";
import { handleSendFile } from "../../common/printBillingApi";
import {
  addBillCounterSell,
  customerNameByMobile,
} from "../counterSellBilling/counterSellBillingApi";
import CustomerModal from "../../common/customerModal";
import { el } from "date-fns/locale";

export default function OldBilling() {
  const [payloadcollection, setPayloadCollection] = useState([]);
  const [billNoR, setBillNoR] = useState(null);
  const [indexTableItem, setIndexTableItem] = useState();
  const navigate = useNavigate();
  const [currentDataArr, setCurrentDataArr] = useState(null);
  // const
  const [billData, setbillData] = useState({});
  const updateBillData = null;
  const tableName = null;
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const componentRefPDF = useRef();
  const [selectedUser, setSelectedUser] = useState(null);
  const handleClose3 = () => setOpen3(false);
  const handleClose2 = () => setOpen2(false);
  const componentRef = useRef();
  const [NextBtnDisplay, setNextBtnDisplay] = useState(false);
  const [eventHandle, setEventHandle] = useState(null);
  const discoundedPrice = ({ allAmount, billData }) => {
    let divideVal = billData.discount
      ? allAmount / billData.discount
      : allAmount;
    if (billData.discountType == "Amount") {
      divideVal = allAmount / billData.discount;
    }
    if (billData.discountType != "Amount") {
      let per = (allAmount * billData.discount) / 100;
      divideVal = allAmount / per;
    }

    return divideVal;
  };
  useEffect(() => {
    let productamount1 = 110;
    let cgst = 5,
      sgst = 5;
    let productamount =
      productamount1 +
      (productamount1 * cgst) / 100 +
      (productamount1 * sgst) / 100;

    let pr2 = 110;
    let cgst2 = 5,
      sgst2 = 5,
      igst = 0;
    let pr2t =
      pr2 + (pr2 * cgst2) / 100 + (pr2 * sgst2) / 100 + (pr2 * igst) / 100;

    console.log("calculated price ", {
      cgst: (pr2 * cgst2) / 100,
      sgst: (pr2 * sgst2) / 100,
      igst: (pr2 * igst) / 100,

      payable: pr2t,
    });

    if (eventHandle) {
      handleSendFile(componentRefPDF, eventHandle?.billNumber, (data) => {
        console.log("responce updateresponce update", data);

        const whatsappLink = `https://web.whatsapp.com/send?phone=${eventHandle?.customerMobile
          }&text=${"Thanks for visiting PALACE THE SALON Your bill amount is Rs. " +
          payableValueCalculate().toFixed(2) +
          " Your Receipt -" +
          data?.data?.pdfBillPath +
          " - Elegant Prime"
          }`;
        window.open(whatsappLink, "_blank");

        setEventHandle(null);
        setPayloadCollection([]);
        setbillData({});
        arrFormat();
      });
    }
  }, [eventHandle]);
  const [CustomerFlag, setCustomerFlag] = useState(false);
  const [displayContinue, setDisplayContinue] = useState(false);
  const removeFromPayloadCollection = (item) => {
    let temp = [...payloadcollection];
    temp = temp.filter((elet) => {
      return elet?.itemId != item?.itemId;
    });
    console.log("removefrompayload ", temp);
    setPayloadCollection([...temp]);
  };
  const removeItem = (index) => {
    let arr = [...billData.counterSalesChild];
    arr.splice(index, 1);
    setbillData({
      ...billData,
      counterSalesChild: arr,
    });
  };
  const [displayPayloadcollection, setDisplayPayloadcollection] = useState([]);

  useEffect(() => {
    let arr = [...payloadcollection];
    arr = arr.map((item, index) => {
      return item;
    });
    let obj = {};
    arr.forEach((ele, index) => {
      console.log("ele doc", ele);
      if (obj[ele.employeeMasterId + "_" + ele.itemId]) {
        obj[ele.employeeMasterId + "_" + ele.itemId] = {
          ...obj[ele.employeeMasterId + "_" + ele.itemId],
          employeePayPercentage:
            parseFloat(
              obj[ele.employeeMasterId + "_" + ele.itemId][
              "employeePayPercentage"
              ]
            ) + parseFloat(ele.employeePayPercentage),
        };
      } else {
        obj[ele.employeeMasterId + "_" + ele.itemId] = { ...ele };
      }
    });
    let arrnew = [
      ...Object.keys(obj).map((key, index) => {
        return obj[key];
      }),
    ];
    setDisplayPayloadcollection([...arrnew]);
  }, [payloadcollection]);
  const navigateCallback = () => {
    if (Object.keys(updateBillData).length === 0) {
      navigate(routePath.COUNTERSELL);
    }
  };
  // useEffect(())

  useEffect(() => {
    console.log("payloadcollectionpayloadcollection ", payloadcollection);
  }, [payloadcollection]);
  const arrFormat = () => {
    //  navigateCallback();
    console.log("Update Bill Data ", updateBillData);
    let cp = [...(updateBillData?.counterSalesChild ?? [])];
    let arr = [...(updateBillData?.counterSalesChild ?? [])].filter(
      (item, index, self) =>
        index === self.findIndex((obj) => obj.itemId === item.itemId)
    );
    let obj = { ...updateBillData };
    obj.counterSalesChild = arr;

    setPayloadCollection(cp);
    setbillData(obj);
  };
  useEffect(() => {
    arrFormat();
  }, []);
  const previousBillDataRef = useRef(billData?.counterSalesChild);

  useEffect(() => {
    console.log("update payloadcollection ", payloadcollection);
  }, [payloadcollection]);
  useEffect(() => {
    console.log("Update Bill Data ", billData);
    //   let cp=[...updateBillData?.counterSalesChild??[]]
    //   let arr=[...updateBillData?.counterSalesChild??[]].filter((item, index, self) =>
    //   index === self.findIndex((obj) => obj.itemId !== item.itemId)
    // );
    // let obj={...updateBillData}
    //   obj.counterSalesChild=arr
    //   setPayloadCollection(cp)
    //   setbillData(obj);
  }, [billData]);
  const [CollectionTableItems, setCollectionTableItems] = useState([]);

  const payableValueCalculate = () => {
    let sum = sumItemPrice().sum;
    console.log("payableValueCalculate sum ", sum);
    let discountPrice = ((billData?.discount ?? 0) / 100) * sum;
    console.log("payableValueCalculate discountPrice ", discountPrice);

    if (billData?.discountType === "Percent") {
      console.log(
        "payableValueCalculate sum - discountPrice ",
        sum - discountPrice
      );

      return sum - discountPrice;
    } else {
      console.log(
        "payableValueCalculate  sum - billData?.discount ",
        sum - billData?.discount
      );

      return sum - (billData?.discount ?? 0);
    }
  };
  const addQuantity = (ele, index) => {
    let obj = { ...ele };
    obj.quantity++;
    let quan = obj.quantity;
    let rate = obj.rate;
    obj.amount = (rate + obj.rate * (obj.gst / 100)) * obj.quantity;
    console.log("eleeleele = ", ele);
    // obj.amount =
    //   (item[1].price + (item[1].price * item[1].gst) / 100) *
    //   item[1].suppliedQuantity;
    let arr = [...billData.counterSalesChild];
    arr[index] = obj;
    setbillData({
      ...billData,
      counterSalesChild: arr,
    });
  };
  const getUniqueElements = (leftArray, rightArray) => {
    // Return elements from rightArray where no matching itemId exists in leftArray
    return rightArray.filter(
      (rightItem) =>
        !leftArray.some((leftItem) => leftItem.itemId === rightItem.itemId)
    );
  };

  const subQuantity = (ele, index) => {
    let obj = { ...ele };
    let arr = [...billData.counterSalesChild];

    if (obj.quantity > 1) {
      obj.quantity--;
      let quan = obj.quantity;
      let rate = obj.rate;
      obj.amount = (rate + obj.rate * (obj.gst / 100)) * obj.quantity;
      arr[index] = obj;
      setbillData({
        ...billData,
        counterSalesChild: arr,
      });
    } else {
      removeItem(index);
      removeFromPayloadCollection(arr[index]);
    }
  };
  const sumItemPrice = () => {
    let sum = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    billData?.counterSalesChild?.forEach((item) => {
      sum += item.amount;
      cgst += (item.amount * item.cgst ?? 1) / 100;
      sgst += (item.amount * item.sgst ?? 1) / 100;
      igst += (item.amount * item.igst ?? 1) / 100;
    });
    return {
      sum: sum,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
    };
  };

  const addAllValue = (arr) => {
    let amount = 0;
    arr.forEach((item) => {
      amount += item.amount;
    });
    return amount;
  };
  const addAllAmount = () => {
    let add = 0;

    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let payableAmount = 0;
    let allAmount = addAllValue(billData.counterSalesChild ?? []);
    let discountDivVal = 0;
    let divideVal = billData.discount
      ? allAmount / billData.discount
      : allAmount; //170/10=17

    // if(billData.discountType=="Amount"){
    //     divideVal=allAmount/billData.discount
    // }
    // if(billData.discountType!="Amount"){
    //   let per=allAmount*billData.discount/100;
    //     divideVal=allAmount/per
    // }
    divideVal = discoundedPrice({
      allAmount,
      billData,
    });
    billData?.counterSalesChild?.forEach((item) => {
      let subVal = item.amount / divideVal; //40/17
      let afterCalculation = 0;
      if (billData.discount) {
        afterCalculation = item.amount - subVal;
      } else {
        afterCalculation = item.amount;
      }
      console.log("afterCalculation ", afterCalculation);
      add += afterCalculation;
      cgst += (afterCalculation * (item.cgst ?? 1)) / 100;
      igst += (afterCalculation * (item.igst ?? 1)) / 100;
      sgst += (afterCalculation * (item.sgst ?? 1)) / 100;
    });

    return {
      sum: add,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
      payableAmount: add + cgst + sgst + igst,
    };
  };
  useEffect(() => { }, [billData]);

  const calculatedPriceWitrhDiscount = (amount, divideVal) => {
    let subVal = amount / divideVal;
    let afterCalculation = 0;
    if (billData.discount) {
      afterCalculation = amount - subVal;
    } else {
      afterCalculation = amount;
    }
    return afterCalculation;
  };
  const discountD = () => {
    if (billData?.discountType === "Percent") {
      return parseFloat((billData?.discount / 100) * sumItemPrice().sum ?? 0);
    }

    if (billData?.discountType !== "Percent") {
      return parseFloat(billData?.discount ?? 0);
    }

    if (billData?.discountType !== "Percent") {
      return parseFloat(billData?.discount ?? 0);
    }

    if (billData?.discountType === "Amount" && billData?.discount === "") {
      return 0;
    }
    return 0;
  };
  const updateBillFunction = (callback) => {
    const valid = validationUpdate(billData);

    let payload = { ...billData };

    let arrpayloadCollection = [...payloadcollection];
    arrpayloadCollection = arrpayloadCollection.filter((ele) => ele != null);

    arrpayloadCollection = arrpayloadCollection.map((ele, index) => {
      let calcaltedPrice = calculatedPriceWitrhDiscount(
        ele.amount,
        discoundedPrice({
          allAmount: addAllValue(billData.counterSalesChild ?? []),
          billData,
        })
      )
      return {
        ...ele,
        employeePayPercentage: parseFloat(ele.employeePayPercentage),
        employeePayPercentage: parseFloat(ele.employeePayPercentage),
        cgstAmount: (calcaltedPrice * (ele.cgst ?? 1)) / 100,
        sgstAmount: (calcaltedPrice * (ele.sgst ?? 1)) / 100,

        igstAmount: (calcaltedPrice * (ele.igst ?? 1)) / 100,

        amount: calculatedPriceWitrhDiscount(
          ele.amount,
          discoundedPrice({
            allAmount: addAllValue(billData.counterSalesChild ?? []),
            billData,
          })
        ),
      };
    });
    payload.counterSalesChild = arrpayloadCollection;
    console.log("payloadpayloadpayload ", payload);
    // return;
    if (valid.status) {
      addBill(
        {
          ...payload,
          customer: payload.customer ? payload.customer : "Cash bill",
          customerMobile: payload.customerMobile ?? "",
          isCounterSalesBill: payload.paymentMode === "Credit" ? false : true,
          paymentMode: payload.paymentMode ?? "Cash",
          discountType: payload.discountType ?? "Amount",
          // discount: parseFloat(payload.discount??0),
          settleBill: true,
          // counterSalesChild: [],
          discount: payload?.discount ? parseFloat(payload?.discount) : 0,
        },
        addBillCounterSell,
        Swal,
        navigate,
        routePath,
        (res) => {
          setBillNoR(3);

          if (callback) {
            // callback({ ...res, customerMobile: payload?.customerMobile, payload: { ...payload } })

            setEventHandle({
              billNumber: res?.data?.data?.billNumber,
              customerMobile: payload?.customerMobile,
            });
          } else {
            setPayloadCollection([]);
            setbillData({});
            arrFormat();
          }

          setDisplayContinue(false);
          setNextBtnDisplay(false);
        }
      );
    } else {
      Swal.fire({
        title: valid.msg,
        text: "",
        icon: "error",

        ...swalAlertPopProps,
      });
    }
  };
  const currentDate = new Date().toISOString().split("T")[0];
  const filterDataForUpdate = () => {
    return;
  };
  return (
    <Box
      sx={{
        overflowY: "auto",
        maxHeight: "calc(100vh - 66px)",
      }}
    >
      <Grid container>
        <Grid item xs={12} container>
          <Grid item xs={8.5}>
            <Grid xs={12} sx={{ height: "3rem" }}>
              <Grid container sx={{ height: "100%" }}>
                <Grid
                  sx={{
                    backgroundColor: (theme) => theme.palette.primary.main,
                    p: "10px",
                    display: "flex",
                    m: 0,
                    alignItems: "center",
                    height: "100%",
                  }}
                  item
                  // xs={6}
                  xs={8}
                >
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{
                      ".MuiBreadcrumbs-separator": {
                        color: "white",
                      },
                    }}
                  >
                    <Typography
                      underline="none"
                      color="white"
                      fontWeight={"700"}
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={() => navigate(routePath.COUNTERSELL)}
                    >
                      Counter Sell Billing
                    </Typography>

                    <Typography
                      underline="none"
                      color="white"
                      fontWeight={"700"}
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      {billData?.customer}
                    </Typography>
                  </Breadcrumbs>
                </Grid>
                <Grid
                  sx={{
                    backgroundColor: (theme) => theme.palette.primary.main,
                    // p: "10px 0px",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    height: "100%",
                  }}
                  item
                  xs={4}
                >
                  <TextField
                    sx={{
                      background: "white",
                      float: "left",
                      borderRadius: "5px",
                      width: "80%",
                      // height: "0rem",
                    }}
                    variant="outlined"
                    placeholder="Search in Menu"
                    InputProps={{
                      style: {
                        height: "2.5rem", // Set the desired height here
                      },
                      endAdornment: (
                        <IconButton type="submit" aria-label="search">
                          <SearchIcon />
                        </IconButton>
                      ),
                    }}
                  />

                  {/* <PersonIcon

              /> */}
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={3}
                sx={{
                  backgroundColor: (theme) => theme.palette.primary.main,
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 107px)",
                  minHeight: "calc(100vh - 107px)",
                  paddingRight: "4px",
                }}
              >
                <MenuSideBar
                  CollectionTableItems={CollectionTableItems}
                  setCollectionTableItems={setCollectionTableItems}
                  indexTableItem={indexTableItem}
                  setIndexTableItem={setIndexTableItem}
                />
              </Grid>

              <Grid
                item
                xs={9}
                sx={{
                  // backgroundColor: (theme) => theme.palette.primary.main,
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 108px)",
                  paddingRight: "4px",
                }}
              >
                <Grid container>
                  {CollectionTableItems[indexTableItem]?.tableItems.map(
                    (item, index) => {
                      return (
                        <Grid
                          item
                          key={"tableitems" + index}
                          xs={3}
                          //   xs={currentDataArr?.length > 0 && addToCardWindow ? 3 : 2}
                          sx={{ p: "10px", textAlign: "center" }}
                        >
                          <Box
                            onClick={() => {
                              console.log("update bi", item);
                              // const ind = billData?.counterSalesChild.filter(
                              //   (table) => table.itemId === item.id
                              // );
                              const ind = billData?.counterSalesChild.findIndex(
                                (table) => table.itemId === item.id
                              );

                              if (ind === -1) {
                                let arr = [...billData.counterSalesChild];
                                let obj = {};
                                obj["itemId"] = item.id;
                                obj["gst"] = item.gst;
                                obj["amountWithPayPercentage"] =
                                  item.amountWithPayPercentage;
                                obj["cgst"] = item.cgst;
                                obj["igstAmount"] = item.igstAmount;

                                obj["cgstAmount"] = item.cgstAmount;
                                obj["igst"] = item.igst;
                                obj["rawMaterialValueWithPayPercentage"] =
                                  item.rawMaterialValueWithPayPercentage;
                                obj["rawMaterialValue"] = item.rawMaterialValue;
                                // obj["employeeMasterId"]=item.employeeMasterId
                                obj["employeeName"] = item.employeeName;
                                obj["employeePayPercentage"] =
                                  item.employeePayPercentage;

                                obj["amount"] =
                                  (item.price + (item.price * item.gst) / 100) *
                                  1;
                                obj["sgst"] = item.sgst;
                                obj["sgstAmount"] = item.sgstAmount;

                                obj["unit"] = item.unit;
                                obj["gstAmount"] = item.gst;
                                obj["itemDescription"] = item.itemDescription;
                                obj["quantity"] = 1;
                                obj["rate"] = item.price;
                                obj["unit"] = item.unit;

                                arr.push(obj);
                                // setPayloadCollection(arr)

                                setbillData({
                                  ...billData,
                                  counterSalesChild: arr,
                                });
                              } else {
                                let arr = [...billData.counterSalesChild];

                                console.log("ind ", arr[ind]);
                                // arr[ind].quantity = arr[ind].quantity + 1;
                                let updatedItem = {
                                  ...arr[ind],
                                  // quantity: arr[ind].quantity + 1,
                                  // amount: arr[ind].amount * arr[ind].quantity,
                                };

                                // Update the array at the specified index with the updated object
                                arr[ind] = updatedItem;

                                setbillData({
                                  ...billData,
                                  counterSalesChild: arr,
                                });
                              }
                            }}
                            sx={{
                              p: "0px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontWeight: "bold",
                              height: "4rem",
                              borderRadius: "10px",
                              color: "#5693a3",
                              cursor: "pointer",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                              ":hover": {
                                bgcolor: "#2892ba17",
                              },
                            }}
                          >
                            {item.itemDescription}
                          </Box>
                        </Grid>
                      );
                    }
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={3.5}
            sx={{
              overflowY: "auto",
              height: "calc(100vh - 60px)",
            }}
          >
            <Box
              sx={{
                p: "10px",
              }}
            >
              <Grid container spacing={2} alignItems="center" mt={1}>
                <Box sx={{}}>
                  <Box
                    sx={{
                      p: "10px",
                      position: "relative",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField fullWidth label="Bill No " size="small" />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Date"
                          type="date"
                          defaultValue={currentDate}
                          InputLabelProps={{
                            shrink: true, // Makes the label stay above the input
                          }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          id="mobileNumber"
                          label="Mobile No"
                          value={billData?.customerMobile}
                          onChange={async (e) => {
                            let name = null;

                            if (e.target.value.length == 10) {
                              //  const calb = await customerNameByMobile({
                              //   customerMobile: e.target.value,
                              // });
                              getUserDetailByNumber(
                                {
                                  customerMobile: e.target.value.replace(
                                    /\D/g,
                                    ""
                                  ),
                                },
                                (res) => {
                                  console.log("  data====", res?.data?.data);
                                  name = res?.data?.data;

                                  setbillData((prev) => {
                                    return {
                                      ...prev,
                                      customer: name,
                                    };
                                  });
                                }
                              );
                            } else {
                            }
                            setbillData((prev) => {
                              return {
                                ...prev,
                                customerMobile: e.target.value.replace(
                                  /\D/g,
                                  ""
                                ),
                              };
                            });
                          }}
                          sx={{
                            textAlign: "center",
                            "& .MuiInputLabel-root": {
                              lineHeight: "0.9rem",
                            },
                            "& .MuiInputBase-root": { height: "2.5rem" },
                            ...(billData.customer
                              ? {}
                              : {
                                "& .MuiInputBase-root::after": {
                                  content: "unset",
                                },
                              }),
                          }}
                          //   InputProps={{
                          //     endAdornment: (
                          //       <AddIcCallIcon
                          //         sx={{
                          //           display: {
                          //             xs: "none",
                          //             lg: "block",
                          //           },
                          //           color: (theme) => theme.palette.primary.main,
                          //         }}
                          //       />
                          //     ),
                          //   }}
                          InputProps={{
                            endAdornment: (
                              <AddIcCallIcon
                                sx={{
                                  display: {
                                    xs: "none",
                                    lg: "block",
                                  },
                                  cursor: "pointer",
                                  color: (theme) => theme.palette.primary.main,
                                }}
                              />
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          id="username"
                          label="Customer Name"
                          value={billData?.customer || ""}
                          onChange={(e) =>
                            setbillData({
                              ...billData,
                              customer: e.target.value,
                            })
                          }
                          size="small"
                          sx={{
                            textAlign: "center",
                            "& .MuiInputLabel-root": {
                              lineHeight: "0.9rem",
                            },
                            "& .MuiInputBase-root": {
                              height: "2.5rem",
                            },
                            ...(billData?.customer
                              ? {}
                              : {
                                "& .MuiInputBase-root::after": {
                                  content: "unset",
                                },
                              }),
                          }}
                          InputProps={{
                            style: {
                              paddingRight: "20px", // Set the desired height here
                            },
                            endAdornment: (
                              <AccountCircleIcon
                                onClick={() => {
                                  setCustomerFlag(true);
                                }}
                                sx={{
                                  display: {
                                    xs: "none",
                                    lg: "block",
                                  },
                                  background: "white",
                                  color: (theme) => theme.palette.primary.main,
                                }}
                              />
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Box>
                          {billData?.counterSalesChild?.length > 0 && (
                            <Box
                              sx={{ display: "flex", flexDirection: "column" }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  borderBottom: "1px solid",
                                  borderColor: "divider",
                                  backgroundColor: "#f5f5f5",
                                  padding: "8px 16px",
                                  fontWeight: "600",
                                  color: "#000000",
                                }}
                              >
                                <Box
                                  sx={{
                                    flex: 4,
                                  }}
                                >
                                  Item
                                </Box>
                                <Box
                                  sx={{
                                    flex: 3,
                                  }}
                                >
                                  Price
                                </Box>

                                <Box
                                  sx={{
                                    flex: 2,
                                  }}
                                >
                                  Qty{" "}
                                </Box>
                                <Box
                                  sx={{
                                    flex: 1,
                                    // color: (theme) => theme.palette.primary.main,
                                  }}
                                >
                                  Amount{" "}
                                </Box>
                              </Box>
                            </Box>
                          )}
                          <Box
                            sx={{
                              overflowY: "auto",
                              height: "20vh",
                            }}
                          >
                            {billData?.counterSalesChild?.map((ele, index) => {
                              // return null
                              console.log("sss= ", ele, " ", index);

                              return (
                                <React.Fragment key={"billlinst" + index}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        borderBottom: "1px solid",
                                        borderColor: "divider",
                                        padding: "8px 16px",
                                        fontWeight: "500",
                                      }}
                                      onClick={() => { }}
                                    >
                                      <Box sx={{ flex: 1 }}>
                                        <CancelIcon
                                          sx={{
                                            color: "#ff2e2e",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            removeItem(index);
                                            removeFromPayloadCollection(
                                              billData?.counterSalesChild[index]
                                            );
                                          }}
                                        />
                                      </Box>

                                      <Box
                                        sx={{
                                          flex: 4,
                                        }}
                                        fontWeight="400"
                                        color={(theme) =>
                                          theme.palette.primary.main
                                        }
                                      >
                                        {ele?.itemDescription}
                                      </Box>
                                      <Box sx={{ flex: 3 }} fontWeight="400">
                                        {ele?.rate}/{ele?.unit}
                                      </Box>
                                      <Box
                                        sx={{
                                          flex: 2,
                                          display: "flex",
                                          alignItems: "center",
                                          color: (theme) =>
                                            theme.palette.secondary.main,
                                        }}
                                      >
                                        <RemoveIcon
                                          style={{
                                            fontSize: "15px",
                                            color: "#333",
                                            border: "1px solid #333",
                                            margin: "5px",
                                            borderRadius: "4px",
                                            padding: "4px 8px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            subQuantity(ele, index);
                                          }}
                                        />

                                        {ele?.quantity}

                                        <AddIcon
                                          style={{
                                            color: "#333",
                                            border: "1px solid #333",
                                            margin: "5px",
                                            fontSize: "15px",
                                            borderRadius: "4px",
                                            padding: "4px 8px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            addQuantity(ele, index);
                                          }}
                                        />
                                      </Box>
                                      <Box
                                        sx={{
                                          flex: 1,
                                          display: "flex",
                                          alignItems: "center",
                                          color: (theme) =>
                                            theme.palette.tertiary.main,
                                        }}
                                      >
                                        <CurrencyRupeeIcon
                                          sx={{ height: "17px" }}
                                        />{" "}
                                        {ele.rate.toFixed(2) * ele?.quantity}
                                      </Box>
                                    </Box>
                                  </Box>
                                  <Grid
                                    key={index}
                                    container
                                    alignItems="center"
                                    style={{
                                      borderBottom: "1px solid",
                                      borderColor: "divider",
                                      padding: "8px 16px",
                                      display: "flex",
                                      backgroundColor:
                                        index % 2 === 1 ? "#f5f5f5" : "",
                                    }}
                                  >
                                    {displayPayloadcollection
                                      .filter((elet) => {
                                        console.log("item?.id== ", elet);
                                        return elet.itemId == ele?.itemId;
                                      })
                                      .map((eleTT, index) => {
                                        return (
                                          <React.Fragment key={"index" + index}>
                                            <p key={"itemele" + index}>
                                              {eleTT.employeeName}
                                            </p>
                                            <p key={"itemele" + index}>
                                              ({eleTT.employeePayPercentage})
                                            </p>
                                          </React.Fragment>
                                        );
                                      })}
                                  </Grid>
                                </React.Fragment>
                              );
                            })}
                          </Box>
                        </Box>

                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              display: "flex",
                              borderBottom: "1px solid",
                              borderColor: "divider",
                              padding: "8px 16px",
                              fontWeight: "500",
                              textAlign: "center",
                            }}
                          >
                            {/* <Box
                              sx={{
                                color: (theme) => theme.palette.primary.main,
                              }}
                            >
                              Total Amount
                              Bill Amount
                            </Box> */}
                            {/* <Box
                              sx={{
                                flex: 3,
                                color: (theme) => theme.palette.secondary.main,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />
                              {TotalAmount(billData).amount}
                            </Box> */}

                            {/* <Box
                              sx={{
                                flex: 2,
                                color: (theme) => theme.palette.primary.main,

                                textDecoration: "underline",

                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOpen2(true);
                              }}
                            >

                              Discount
                            </Box> */}
                            {/* <Box
                              sx={{
                                flex: 2,
                                color: (theme) => theme.palette.primary.main,
                              }}
                            >
                              Payable Amount
                              {billData?.discountType === "Percent" &&
                              billData?.discount === ""
                                ? ""
                                : ""}

                              {billData?.discountType === "Percent"
                                ? billData?.discount + "%"
                                : ""}
                            </Box> */}
                            {/* <Box
                              sx={{
                                flex: 2,
                                // textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: (theme) => theme.palette.secondary.main,
                              }}
                            >
                              {" "}
                              <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />
                              {billData?.discountType === "Percent" &&
                                // (billData?.discount / 100) * billData?.netAmount}
                                (billData?.discount / 100) * sumItemPrice().sum}
                              {billData?.discountType !== "Percent" &&
                                // (billData?.discount / 100) * billData?.netAmount}
                                billData?.discount}
                              {billData?.discountType === "Amount" &&
                              billData?.discount === ""
                                ? 0
                                : ""}
                            </Box> */}
                          </Box>
                          {/* Bill Amount Start */}
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                textAlign: "center",
                                padding: "8px 16px",
                                // fontWeight: "bold",
                                fontWeight: "500",
                              }}
                            >
                              <Box
                                sx={{
                                  color: (theme) => theme.palette.primary.main,
                                }}
                              >
                                Bill Amount :{/* Discount */}
                              </Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  display: "flex",
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  justifyContent: "center",
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "end",
                                }}
                              >
                                <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />
                                {TotalAmount(billData).amount}
                              </Box>
                            </Box>
                          </Box>
                          {/* Bill Amount End */}

                          {/* CGST Start */}
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                textAlign: "center",
                                padding: "8px 16px",
                                // fontWeight: "bold",
                                fontWeight: "500",
                              }}
                            >
                              <Box
                                sx={{
                                  color: (theme) => theme.palette.primary.main,
                                }}
                              >
                                CGST(%) :{/* Discount */}
                              </Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  display: "flex",
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  justifyContent: "center",
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "end",
                                }}
                              >
                                {billData?.sgst}

                                <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />
                                {addAllAmount().cgst}

                                {/* {billData?.discountAmount} */}
                              </Box>
                            </Box>
                          </Box>
                          {/* CGST End */}

                          {/* SGST Start */}
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                textAlign: "center",
                                padding: "8px 16px",
                                // fontWeight: "bold",
                                fontWeight: "500",
                              }}
                            >
                              <Box
                                sx={{
                                  color: (theme) => theme.palette.primary.main,
                                }}
                              >
                                SGST(%) :{/* Discount */}
                              </Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  display: "flex",
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  justifyContent: "center",
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "end",
                                }}
                              >
                                {/* {billData?.billAmount} */}
                                <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />
                                {addAllAmount().sgst}

                                {/* {billData?.discountAmount} */}
                              </Box>
                            </Box>
                          </Box>
                          {/* SGST End */}

                          {/* IGST Start */}
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                textAlign: "center",
                                padding: "8px 16px",
                                // fontWeight: "bold",
                                fontWeight: "500",
                              }}
                            >
                              <Box
                                sx={{
                                  color: (theme) => theme.palette.primary.main,
                                }}
                              >
                                IGST(%) :{/* Discount */}
                              </Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  display: "flex",
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  justifyContent: "center",
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "end",
                                }}
                              >
                                {/* {billData?.billAmount} */}
                                <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />
                                {addAllAmount().igst}

                                {/* {billData?.discountAmount} */}
                              </Box>
                            </Box>
                          </Box>
                          {/* IGST End */}

                          {/* Discount Start */}
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                textAlign: "center",
                                padding: "8px 16px",
                                // fontWeight: "bold",
                                fontWeight: "500",
                              }}
                            >
                              <Box
                                sx={{
                                  color: (theme) => theme.palette.primary.main,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setOpen2(true);
                                }}
                              >
                                Discount :
                              </Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  display: "flex",
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  justifyContent: "center",
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "end",
                                }}
                              >
                                {/* {billData?.billAmount} */}
                                <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />

                                {discountD()?.toFixed(2)}
                                {/* {billData?.discountType === "Percent" &&
                                                                billData?.discount === ""
                                                                ? ""
                                                                : ""}

                                                            {billData?.discountType === "Percent"
                                                                ? billData?.discount + "%"
                                                                : ""} */}

                                {/* {billData?.discountType === "Percent" &&
                                  (
                                    (billData?.discount / 100) * sumItemPrice().sum ?? 0
                                  )}

                                {billData?.discountType !== "Percent" &&
                                  (billData?.discount ?? 0)}

                                {billData?.discountType === "Amount" && billData?.discount === "" ? 0 : ""} */}

                                {/* {billData?.discountAmount} */}
                              </Box>
                            </Box>
                          </Box>
                          {/* Discount End */}

                          {/* Payable Amount Start */}
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                textAlign: "center",
                                padding: "8px 16px",
                                // fontWeight: "bold",
                                fontWeight: "500",
                              }}
                            >
                              <Box
                                sx={{
                                  color: (theme) => theme.palette.primary.main,
                                }}
                              >
                                Payable Amount :
                              </Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  display: "flex",
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  justifyContent: "center",
                                }}
                              ></Box>
                              <Box
                                sx={{
                                  flex: 3,
                                  color: (theme) =>
                                    theme.palette.secondary.main,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "end",
                                }}
                              >
                                <CurrencyRupeeIcon sx={{ fontSize: "17px" }} />

                                {addAllAmount().payableAmount.toFixed(2)}
                                {/* {billData?.discountAmount} */}
                              </Box>
                            </Box>
                          </Box>
                          {/*  Payable Amount End */}
                        </Box>
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        flex: 9,
                        color: (theme) => theme.palette.secondary.main,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={billData?.paymentMode ?? "Cash"}
                        onChange={(e) => {
                          setbillData({
                            ...billData,
                            paymentMode: e.target.value,
                          });
                          // setBill({
                          //   ...bill,
                          //   paymentMode: e.target.value,
                          // });
                        }}
                      >
                        <FormControlLabel
                          value="Cash"
                          control={<Radio />}
                          label={
                            <Box sx={{ display: "flex" }}>
                              <CurrencyRupeeIcon sx={{ fontSize: "20px" }} />
                              Cash{" "}
                            </Box>
                          }
                        />
                        <FormControlLabel
                          value="Credit"
                          selected={true}
                          control={<Radio />}
                          label={
                            <Box sx={{ display: "flex" }}>
                              <CurrencyRupeeIcon sx={{ fontSize: "20px" }} />
                              Credit{" "}
                            </Box>
                          }
                        />
                        <FormControlLabel
                          value="Digital"
                          control={<Radio />}
                          label={
                            <Box sx={{ display: "flex" }}>
                              <CurrencyRupeeIcon sx={{ fontSize: "20px" }} />
                              Online{" "}
                            </Box>
                          }
                        />
                      </RadioGroup>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                      }}
                    >
                      {NextBtnDisplay && (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            sx={{
                              width: "100%",
                              m: "10px",
                            }}
                            onClick={() => {
                              updateBillFunction();
                            }}
                          >
                            {" "}
                            Save
                          </Button>
                          {/* <Button
                      variant="contained"
                      sx={{
                        width: "100%",
                        m: "10px",
                      }}
                      onClick={() => {
                        // let valid = updateBillValidation(billData);
                        // if (valid.status) {
                        //   setOpen3(true);
                        // } else {
                        //   Swal.fire({
                        //     text: valid.msg,
                        //     icon: "warning",
                        //     ...swalAlertPopProps,
                        //   });
                        // }
                      }}
                    >
                      {" "}
                      Print
                    </Button> */}
                          <ReactToPrint
                            trigger={() => (
                              <Button
                                variant="contained"
                                sx={{
                                  width: "100%",
                                  m: "10px",
                                }}
                                // sx={{
                                //   // width: "50%",
                                //   mt: "10px",
                                //   display: "inline-block",
                                //   mb: "10px",
                                // }}
                                onClick={() => {
                                  // setKOT();
                                  // addDataCallBack();
                                  // setOpen2(false);
                                }}
                              >
                                {" "}
                                Save & Print
                              </Button>
                            )}
                            content={() => componentRef.current}
                            onBeforePrint={() => {
                              // setOpen2(false);
                              // addDataCallBack();
                              updateBillFunction();
                              // savePrintBill(
                              //   bill,
                              //   creditValidtionCheck,
                              //   Swal,
                              //   userDetail,
                              //   saveBill,
                              //   saveBillCbUser
                              // );
                            }}
                          ></ReactToPrint>
                          <Button
                            variant="contained"
                            sx={{
                              width: "100%",
                              m: "10px",
                            }}
                            onClick={() => {
                              if (billData?.customerMobile?.length !== 10) {
                                Swal.fire({
                                  title: "Please Enter Mobine Number",
                                  icon: "error",
                                  ...swalAlertPopProps,
                                });
                              } else {
                                updateBillFunction((res) => {
                                  console.log(
                                    "responce update",
                                    res?.data?.data?.billNumber
                                  );
                                  if (res?.data?.data?.billNumber) {
                                  }
                                });
                              }
                            }}
                          >
                            {" "}
                            Save & Share
                          </Button>
                        </React.Fragment>
                      )}
                      {!NextBtnDisplay && (
                        <Button
                          variant="contained"
                          sx={{
                            width: "100%",
                            m: "10px",
                          }}
                          onClick={() => {
                            setOpen4(true);
                          }}
                        >
                          {" "}
                          Continue
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <DiscountModal
        open={open2}
        handleClose={handleClose2}
        bill={{
          ...billData,

          discount: billData.discount,
          discountType: billData?.discountType
            ? billData?.discountType
            : "Amount",
          amount: TotalAmount(billData).priceWithoutGst,
          // amount:billData.netAmount?billData.netAmount:billData.amount,
          paybill: payableValueCalculate().toFixed(2) ?? 0,
        }}
        setBill={(data) => {
          for (let prop in data) {
            // if (!billData.hasOwnProperty(prop)) {
            // }
          }
          setbillData((prev) => {
            let prevData = { ...prev, ...data };

            // prevData.amount = data.amount === NaN ? 0 : data.amount;
            return prevData;
          });
        }}
        setOpen={setOpen2}
      />
      <PrintBilling
        open2={open3}
        handleClose2={handleClose3}
        componentRef={componentRef}
        currentDataArr={billData?.counterSalesChild}
        tableName={tableName}
        priceWithoutGst={TotalAmount(billData).priceWithoutGst}
        // setKOT={setKOT}
        // setBill={setBill}
        setOpen2={setOpen3}
        addDataCallBack={() => {
          updateBil(
            {
              ...billData,
              discount: billData?.discount ? parseFloat(billData?.discount) : 0,
            },
            UpdateBillCounterSell,
            Swal,
            navigate,
            routePath
          );
        }}
        payableBilUpdateBill={payableValueCalculate}
        paybill={addAllAmount().payableAmount.toFixed(2) ?? 0}
        paymentAttribute={addAllAmount()}
        userDetail={userDetail}
        discountType={billData?.discountType}
        discount={1}
        totalAmountBill={TotalAmount(billData).amount}
        discountAmount={
          (function () {
            if (billData?.discountType === "Percent") {
              return (billData?.discount / 100) * sumItemPrice().sum;
            }
            return billData?.discount;
          })()
          // billData?.discount
        }
        addtoCardProductCBUser={billData?.counterSalesChild}
      />
      <PrintBillingPdf
        open2={open3}
        customerMobile={eventHandle?.customerMobile}
        handleClose2={handleClose3}
        billNoR={eventHandle?.billNumber}
        componentRef={componentRefPDF}
        currentDataArr={billData?.counterSalesChild}
        tableName={tableName}
        bill={billData}
        priceWithoutGst={TotalAmount(billData).priceWithoutGst}
        // setKOT={setKOT}
        // setBill={setBill}
        setOpen2={setOpen3}
        addDataCallBack={() => {
          updateBil(
            {
              ...billData,
              discount: billData?.discount ? parseFloat(billData?.discount) : 0,
            },
            UpdateBillCounterSell,
            Swal,
            navigate,
            routePath
          );
        }}
        payableBilUpdateBill={payableValueCalculate}
        // paybill={payableValueCalculate()}
        // paymentAttribute={sumItemPrice()}
        paybill={addAllAmount().payableAmount.toFixed(2) ?? 0}
        paymentAttribute={addAllAmount()}
        userDetail={userDetail}
        discountType={billData?.discountType}
        discount={1}
        totalAmountBill={TotalAmount(billData).amount}
        discountAmount={
          (function () {
            if (billData?.discountType === "Percent") {
              return (billData?.discount / 100) * sumItemPrice().sum;
            }
            return billData?.discount;
          })()
          // billData?.discount
        }
        addtoCardProductCBUser={billData?.counterSalesChild}
      />
      <Pop
        open={open4}
        setOpen={setOpen4}
        data={billData?.counterSalesChild}
        arrCollectionCb={(data) => {
          setDisplayContinue(true);
          setPayloadCollection(data);
        }}
        NextDisplayCb={(data) => {
          setNextBtnDisplay(data);
        }}
        eleCompairedIndex={1}
      />
      <CustomerModal
        open={CustomerFlag}
        setOpen={setCustomerFlag}
        setSelectedUser={(data) => {
          console.log("datadatadata ", data);
          setbillData((prev) => {
            return {
              ...prev,
              customer: data.name ?? "",
              customerMobile: data.customerMobile ?? "",
            };
          });
        }}
      />
    </Box>
  );
}